export enum usAndTerritoriesCode {
  US = 'US',
  AS = 'AS',
  GU = 'GU',
  MH = 'MH',
  FM = 'FM',
  MP = 'MP',
  PW = 'PW',
  PR = 'PR',
  VI = 'VI'
}

export const usAndTerritoriesCodeToNameMap = {
  [usAndTerritoriesCode.US]: 'United States of America',
  [usAndTerritoriesCode.AS]: 'American Samoa',
  [usAndTerritoriesCode.GU]: 'Guam',
  [usAndTerritoriesCode.MH]: 'Marshal Islands',
  [usAndTerritoriesCode.FM]: 'Micronesia, Federated States',
  [usAndTerritoriesCode.MP]: 'Northern Mariana Islands',
  [usAndTerritoriesCode.PW]: 'Palau',
  [usAndTerritoriesCode.PR]: 'Puerto Rico',
  [usAndTerritoriesCode.VI]: 'U.S. Virgin Islands'
}

export const usAndTerritories = [
  { value: usAndTerritoriesCode.US, label: usAndTerritoriesCodeToNameMap.US },
  { value: usAndTerritoriesCode.AS, label: usAndTerritoriesCodeToNameMap.AS },
  { value: usAndTerritoriesCode.GU, label: usAndTerritoriesCodeToNameMap.GU },
  { value: usAndTerritoriesCode.MH, label: usAndTerritoriesCodeToNameMap.MH },
  { value: usAndTerritoriesCode.FM, label: usAndTerritoriesCodeToNameMap.FM },
  { value: usAndTerritoriesCode.MP, label: usAndTerritoriesCodeToNameMap.MP },
  { value: usAndTerritoriesCode.PW, label: usAndTerritoriesCodeToNameMap.PW },
  { value: usAndTerritoriesCode.PR, label: usAndTerritoriesCodeToNameMap.PR },
  { value: usAndTerritoriesCode.VI, label: usAndTerritoriesCodeToNameMap.VI }
]
